const BaseComponent = require('common/home/view');
// const Server = require('helper/server');

// const listTpl = Handlebars.templates['common/home/templates/activity-list-item'];

class Home extends BaseComponent {
  constructor () {
    super();
    this.init();
  }

  init () {
  }
}

module.exports = Home;
